/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductConsentsResponseDto } from '../models/pom-product-consents-response-dto';


/**
 * the Consents presentation API
 */
@Injectable({
  providedIn: 'root',
})
export class ConsentsPresentationService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getConsents
   */
  static readonly GetConsentsPath = '/product-consent';

  /**
   * Get consents
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsents$Response(params: {
    productCode: string;
    variantCode?: string;
    languages?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomProductConsentsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConsentsPresentationService.GetConsentsPath, 'get');
    if (params) {
      rb.query('productCode', params.productCode, {});
      rb.query('variantCode', params.variantCode, {});
      rb.query('languages', params.languages, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomProductConsentsResponseDto>;
      })
    );
  }

  /**
   * Get consents
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsents(params: {
    productCode: string;
    variantCode?: string;
    languages?: Array<string>;
  },
  context?: HttpContext

): Observable<PomProductConsentsResponseDto> {

    return this.getConsents$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomProductConsentsResponseDto>) => r.body as PomProductConsentsResponseDto)
    );
  }

}
